/**
 *
 * all assignable animations for the progress shown on the toasts
 *
 * @export
 * @enum ToastProgressAnimation
 */
export enum ToastProgressAnimation {
  Decr = "decreasing",
  Incr = "increasing",
}
